var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "__TEMP__SVG__",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 13.333,
    viewBox: "0 0 20 13.333",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2127",
    "data-name": "Path 2127",
    d: "M13.333,10.666A2.667,2.667,0,1,1,10.666,8,2.667,2.667,0,0,1,13.333,10.666Z",
    transform: "translate(-0.665 -4)",
    fill: "#5e5e5e"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2128",
    "data-name": "Path 2128",
    d: "M20.451,9.941a14.123,14.123,0,0,0-4.136-4.189A10.466,10.466,0,0,0,10.652,4,9.981,9.981,0,0,0,5.474,5.5,15.18,15.18,0,0,0,.9,9.924,1.33,1.33,0,0,0,.878,11.4,13.921,13.921,0,0,0,4.972,15.6a10.323,10.323,0,0,0,5.68,1.734,10.516,10.516,0,0,0,5.675-1.738,13.924,13.924,0,0,0,4.128-4.2,1.342,1.342,0,0,0,0-1.448Zm-9.784,4.725a4,4,0,1,1,4-4A4,4,0,0,1,10.666,14.666Z",
    transform: "translate(-0.665 -4)",
    fill: "#5e5e5e"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.31a3c7800b57dc52311addfbd1f7f31a.svg";
export { ForwardRef as ReactComponent };